import axios from 'axios';

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    // timeout: 2000,
    headers: {
        platform: 'web',
        'Access-Control-Allow-Origin': '*',
    },
});

export const baseURL = process.env.REACT_APP_BASE_URL;